export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";